import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import { makeStore } from './redux';
import Layout from './components/common/Layout';
import OrganizationsPage from './pages/organizations';
import OrganizationsEditPage from './pages/organizations/edit';
import EventsPage from './pages/events';
import EventsEditPage from './pages/events/edit';
import AdsPage from './pages/ads';
import AdsEditPage from './pages/ads/edit';
import LoginPage from './pages/login';
import MembershipPage from './pages/membershipPage';
import BusinessMetrics from './pages/business-metrics';
import UsersPage from './pages/users';
import UsersEditPage from './pages/users/edit';
import CatalogPages from './pages/catalog-pages';
import CatalogEditPage from './pages/catalog-pages/edit';

const store = makeStore();

const Home = () => <div />;

class RootApp extends Component {
  render() {
    return (
      <Provider store={store}>
        <Router>
          <Switch>
            <Route path="/login" component={LoginPage} />
            <Layout>
              <Route exact path="/" component={Home} />
              <Route
                exact
                path="/organizations"
                component={OrganizationsPage}
              />
              <Route
                exact
                path="/organizations/:id/edit"
                component={OrganizationsEditPage}
              />
              <Route exact path="/events" component={EventsPage} />
              <Route exact path="/events/:id/edit" component={EventsEditPage} />
              <Route exact path="/membership" component={MembershipPage} />
              <Route
                exact
                path="/business-metrics"
                component={BusinessMetrics}
              />
              <Route exact path="/users" component={UsersPage} />
              <Route exact path="/users/:id/edit" component={UsersEditPage} />
              <Route exact path="/catalog-pages" component={CatalogPages} />
              <Route
                exact
                path="/catalog-pages/new"
                component={CatalogEditPage}
              />
              <Route
                exact
                path="/catalog-pages/:id/edit"
                component={CatalogEditPage}
              />
              <Route exact path="/ads" component={AdsPage} />
              <Route exact path="/ads/edit/:id" component={AdsEditPage} />
              <Route exact path="/ads/new" component={AdsEditPage} />
            </Layout>
          </Switch>
        </Router>
      </Provider>
    );
  }
}

export default RootApp;



// WEBPACK FOOTER //
// ./src/App.js